export default __webpack_public_path__ + "media/images/features/jtb/hero-line-bg-e851acb4dae818579fb227387feaa564.png";